import { isoDateToDateString } from "@/Helpers/times-ago";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/shadcnComponents/ui/dialog";

type Campaign = {
  id: number;
  brandName: string;
  campaignId: string;
  campaignName: string;
  expectedLive: string;
  pocName: string;
  pocPhone: string;
  pocEmail: string;
  productInfo: {
    websiteLink: string;
    brief: string;
    resources: string;
  };
};

type CampaignDetailsDialogProps = {
  campaign: Campaign | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function CampaignDetailsDialog({
  campaign,
  open,
  onOpenChange,
}: CampaignDetailsDialogProps) {
  if (!campaign) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] max-h-[600px] overflow-auto ">
        <DialogHeader>
          <DialogTitle>{campaign.campaignName}</DialogTitle>
          <DialogDescription>Campaign Details</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <span className="font-medium">Campaign ID:</span>
            <span className="col-span-3">{campaign.campaignId}</span>
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <span className="font-medium">Expected Live:</span>
            <span className="col-span-3">
              {campaign.expectedLive
                ? isoDateToDateString(campaign.expectedLive)
                : "N/A"}
            </span>
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <span className="font-medium">POC Name:</span>
            <span className="col-span-3">{campaign.pocName}</span>
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <span className="font-medium">POC Phone:</span>
            <span className="col-span-3">{campaign.pocPhone}</span>
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <span className="font-medium">POC Email:</span>
            <span className="col-span-3">{campaign.pocEmail}</span>
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <span className="font-medium">Website Link:</span>
            <span className="col-span-3">
              <a
                href={campaign.productInfo.websiteLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                {campaign.productInfo.websiteLink}
              </a>
            </span>
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <span className="font-medium">Brief:</span>
            <span className="col-span-3">{campaign.productInfo.brief}</span>
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <span className="font-medium">Resources:</span>
            <span className="col-span-3">
              <a
                href={campaign.productInfo.resources}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                {campaign.productInfo.resources}
              </a>
            </span>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
